var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.822 8.084H15.6m-3.112 3.589H15.6m-7.556 3.589H15.6M4 7.813v7.627c0 2.478 1.323 3.814 3.778 3.814h6.697c1.565 0 1.705 1.275 2.833 1.958 1.184.718 2.692-.144 2.692-1.539V7.813C20 5.336 18.677 4 16.222 4H7.778C5.323 4 4 5.336 4 7.813Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.32e91e802cc5170c5624516ee4ffe1d0.svg";
export { ForwardRef as ReactComponent };